var _Rect, _Rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect } from "react-native-svg";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-pause"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    x: 6,
    y: 4,
    width: 4,
    height: 16
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    x: 14,
    y: 4,
    width: 4,
    height: 16
  })));
};
export default SvgPause;